export function isImage(url: string) {
  return url.match(/\.(jpeg|jpg|gif|png)/) != null;
}
